import { useEffect } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Typography, Label, Icon } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { type AuthorizationDocumentStore } from 'pages/settings/ui/AuthorizationDocumentCommon/store/AuthorizationDocumentStore'
import styles from './styles.module.scss'

export const AuthorizationDocumentCommon = observer(
  ({ authorizationDocumentStore }: { authorizationDocumentStore: AuthorizationDocumentStore }) => {
    const { email, disposeStep } = authorizationDocumentStore

    useEffect(() => {
      return () => {
        disposeStep()
      }
    }, [])

    return (
      <div className={styles.wrap}>
        <Typography
          tag={'div'}
          color='tertiary'
          variant='body-md-regular'
          ariaLabel='EnterNumberDescription'
          marginTop='16px'
        >
          Please enter the email address where you would like us to send the LOA. Sign the
          Authorization Document (LOA) and start sending SMS from your landline.
        </Typography>

        <div className={styles.content}>
          <Box marginBottom={4}>
            <Label
              marginBottom={3}
              label={{
                text: 'Email',
              }}
            />

            <div className={styles.fields}>
              <div className={styles.field}>
                <Typography
                  variant={'text-input-field-r'}
                  ariaLabel={'fieldLabel'}
                  color={'var(--content-primary-tertiary)'}
                >
                  To:
                </Typography>
                <TextField
                  className={styles.field__input}
                  variant={'integrated'}
                  readOnly
                  size={'medium'}
                  value={email}
                />
              </div>
            </div>
          </Box>

          <Box>
            <div className={styles.info}>
              <div className={styles.infoCard}>
                <div className={styles.infoCard__icon}>
                  <Icon fontSize={20} icon={'email'} />
                </div>

                <Typography
                  ariaLabel={'infoText'}
                  variant={'body-md-regular'}
                  color={'var(--content-primary-tertiary)'}
                >
                  Login in into your e-mail account, open the Letter of Agreement document that
                  we’ve sent you.
                </Typography>
              </div>

              <div className={styles.infoCard}>
                <div className={styles.infoCard__icon}>
                  <Icon fontSize={20} icon={'signature'} />
                </div>

                <Typography
                  ariaLabel={'infoText'}
                  variant={'body-md-regular'}
                  color={'var(--content-primary-tertiary)'}
                >
                  Sign the document. We will process it and send you an email when your line is
                  active.
                </Typography>
              </div>
            </div>
          </Box>
        </div>
      </div>
    )
  }
)
